(() => {
  function init() {
    document.querySelectorAll('[data-mc-joint-basket]').forEach(node => {
      if (node.dataset.initialized) return;
      node.dataset.initialized = 'true';
      const root = node.closest('[data-section-type="product"]');
      if (!root) return;
      const designs = JSON.parse(node.textContent);
      function showDesign(name) {
        const design = designs[name];
        if (!design) return;
        const title = root.querySelector('.product-single__title');
        const description = root.querySelector('[data-mc-product-description]');
        if (title) title.textContent = design.title;
        if (description) description.innerHTML = design.description;
      }
      root.addEventListener('change', event => {
        if (event.target.matches('input[data-variant-input][name="Name"]')) showDesign(event.target.value);
      });
      if (new URLSearchParams(location.search).has('variant')) {
        const selected = root.querySelector('input[data-variant-input][name="Name"]:checked');
        if (selected) showDesign(selected.value);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
